/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EvaluationParameterLimitType } from './EvaluationParameterLimitType';
import {
    instanceOfEvaluationParameterLimitType,
    EvaluationParameterLimitTypeFromJSON,
    EvaluationParameterLimitTypeFromJSONTyped,
    EvaluationParameterLimitTypeToJSON,
} from './EvaluationParameterLimitType';

/**
 * @type CreateNumericEvaluationParameterDtoLimitType
 * 
 * @export
 */
export type CreateNumericEvaluationParameterDtoLimitType = EvaluationParameterLimitType;


export function CreateNumericEvaluationParameterDtoLimitTypeFromJSON(json: any): CreateNumericEvaluationParameterDtoLimitType {
    return CreateNumericEvaluationParameterDtoLimitTypeFromJSONTyped(json, false);
}

export function CreateNumericEvaluationParameterDtoLimitTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNumericEvaluationParameterDtoLimitType {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...EvaluationParameterLimitTypeFromJSONTyped(json, true) };
    return  EvaluationParameterLimitTypeFromJSONTyped(json, true);
}

export function CreateNumericEvaluationParameterDtoLimitTypeToJSON(value?: CreateNumericEvaluationParameterDtoLimitType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfEvaluationParameterLimitType(value)) {
        return EvaluationParameterLimitTypeToJSON(value as EvaluationParameterLimitType);
    }

    return {};
}

/**
 * Check if a given object implements the CreateNumericEvaluationParameterDtoLimitType interface.
 */
export function instanceOfCreateNumericEvaluationParameterDtoLimitType(value: any): value is CreateNumericEvaluationParameterDtoLimitType {
    if (instanceOfEvaluationParameterLimitType(value)) return true;
    return false;
}

